<template>
  <div class="justify-content-center">
    <div class="row">

    <div class="col-sm-12 col-md-8 col-lg-6 card shadow p-0 offset-md-2 offset-lg-3" style="margin-top:20vh">
      <div class="row no-gutters">
        <div class="col-md-6 d-none d-md-block no-gutters" id="bgLogin">
          <div id="logoLogin">
            <img src="./../../assets/images/@xbest/3x/Ativo 1@3x.png" class=" col-10 image-fluid" alt="Lembra Fácil">
          </div>
        </div>
        <div class="col-md-6 ">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-12 mt-4 mb-4">

                  <form class="col-12 mt-4 mb-4" v-on:submit.prevent="logar">
                    <h4 class="text-center d-none d-md-block">Entrar no sistema</h4>
                    <h4 class="text-center d-block d-md-none">
                      <img src="./../../assets/images/logo.png" class="image-fluid" alt="Lembra Fácil">
                    </h4>
                    <input v-model="form.login" type="text" class="form-control mt-3" placeholder="Login" required autofocus>
                    <input v-model="form.password" type="password" class="form-control mt-2" placeholder="Password" required>
                    <button class="btn btn-lg btn-primary btn-block mt-2" type="submit">Entrar</button>

                    <my-alert
                      class="alert-danger mt-2"
                      :message ='errorMessage'
                      :show='showError'
                      closeButton='true'
                    ></my-alert>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'login',

  data() {
    return {
      showError: false,
      form: {
        login: '',
        password: '',
      },
    };
  },

  beforeCreate() {
    if (this.$store.getters.isLogged) {
      this.$router.push('/');
    }
  },

  methods: {
    logar() {
      this.showError = false;
      this.$http.post('/loginFinanceiro', this.form).then(response => {
        if (response.success) {
          this.$store.commit('user_login',response);
        } else {
          this.errorMessage = response.message;
          this.showError = true;
        }
      });
    }
  }
};
</script>

<style>
#logoLogin {
  position: absolute;
  top: 35%;
  width: 90%;
  left: 15px;
  font-size: 50px;
  text-align: center;
  font-weight: bold;
}
#logoLogin .blue {
  color: #1996cd;
  text-shadow: white 1px 1px 0px;
}
#logoLogin .white{
  color: white;
  text-shadow: #1996cd 1px 1px 0px;
}
#bgLogin {
  /* background-position: center center; */
  /* background-repeat: no-repeat; */
  border-radius: .5rem 0 0 .5rem;
}


</style>
